export default {
    WARPED_TO: 'You have warped to {{name}}.',

    CANNOT_WARP_ACHIEVEMENT: 'This warp requires an achievement to be finished before use.',
    CANNOT_WARP_QUEST: 'You must complete {{questName}} to warp to {{name}}.',
    CANNOT_WARP_LEVEL: 'You must be at least level {{level}} to warp here.',
    CANNOT_WARP_JAIL: 'You cannot teleport, you are jailed for another {{time}}.',
    CANNOT_WARP_TUTORIAL: 'You must finish the tutorial before warping.',
    CANNOT_WARP_COMBAT: 'You must wait 10 seconds after finishing combat to warp.',
    CANNOT_WARP_COOLDOWN: 'You must wait another {{time}} to warp.'
} as const;
